module.exports = __webpack_public_path__ + "static/job_title.7770a2e1.svg";